"use client"

import * as React from "react"
import { initializeGA } from "@/utils"

export function GoogleAnalytics() {
  React.useEffect(() => {
    initializeGA()
  }, [])

  return null
}
